import * as React from 'react';

import ContactSupportForm from '@app/components/Pages/ContactSupport/ContactSupportForm';
import '@app/scss/pages/contactSupport.scss';

const ContactSupport: React.FC = () => {
	return <>
		<div className="support-page-container">
			<h1 className="heading">We're here to help</h1>
			<h2 className="heading">Message our Service Team</h2>
			<div className="support-form-container">
				<ContactSupportForm />
			</div>
		</div>
	</>;
};

export default ContactSupport;
